// Build-time configuration. Vite inlines VITE_* variables when the console is
// built, so each stage gets its own bundle pointing at its own API and Cognito pool.
// In CI they come from SSM (/xq/<stage>/...); locally from console/.env.local.

// Comma-separated Cognito identity-provider names, e.g. "Google,Microsoft"
const ssoProviders: string[] = String(import.meta.env.VITE_SSO_PROVIDERS ?? "")
  .split(",")
  .map((s: string) => s.trim())
  .filter(Boolean);

export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  // Public widget API (https://api.<domain>/widget): the customer quote page (/q/<token>) reads it
  publicApiBaseUrl: import.meta.env.VITE_PUBLIC_API_URL ?? "",
  stage: import.meta.env.VITE_STAGE ?? "local",

  cognito: {
    region: import.meta.env.VITE_COGNITO_REGION ?? "eu-west-2",
    // Public app client (no secret) used for sign-in, sign-up and token refresh
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
    // Hosted UI domain used for SSO redirects, e.g. auth.dev.xenquote.com
    domain: import.meta.env.VITE_COGNITO_DOMAIN ?? "",
    ssoProviders,
  },

  // xenscope, promoted on the dashboard. A separate product with separate accounts.
  xenscopeAppUrl: import.meta.env.VITE_XENSCOPE_APP_URL ?? "https://app.xenscope.com",

  // Local development only: skip sign-in so pages can be built before Cognito
  // exists. Ignored in production builds (import.meta.env.DEV is false there).
  authBypass: import.meta.env.DEV && import.meta.env.VITE_AUTH_BYPASS === "true",
};

/** True when email/password sign-in can work in this build. */
export const passwordAuthConfigured = Boolean(config.cognito.clientId);
